module.exports = __webpack_public_path__ + "img/CV-ROVERE.b939df27.png";